import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import HeroSection from '../components/HeroSection';
import FounderSection from '../components/FounderSection';
import ContactSection from '../components/ContactSection';

const AboutPage: React.FC = () => {
  return (
    <>
      <HeroSection 
        title="आमचे संस्थापक"
        subtitle="किशोर सलगर - विमा आणि सामाजिक सेवेतील दूरदृष्टी असलेले नेते"
        buttonText="आमच्याशी संपर्क साधा"
        buttonLink="#contact"
      />
      
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={4} className="mb-4">
              <img
                src="https://static.wixstatic.com/media/5d7913_0e391af88ce6445a8fe7837fba8728be~mv2.png/v1/crop/x_147,y_171,w_647,h_647/fill/w_410,h_410,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202023-06-07%20at%2021_05_edite.png"
                alt="Founder Kishor Salgar"
                className="img-fluid rounded shadow"
                style={{ maxHeight: '410px', objectFit: 'cover' }}
              />
            </Col>

            <Col lg={8}>
              <div className="mb-5">
                <h2>किशोर सलगर</h2>
                <p className="lead">
                  जीवन आधार विमा सेवा केंद्र, जीवन आधार फाउंडेशन आणि 
                  जीवन आधार महिला ग्रामीण बिगरशेती पतसंस्था यांचे संस्थापक
                </p>

                <p>
                  किशोर सलगर हे विमा क्षेत्रातील एक प्रतिष्ठित नेते असून त्यांना समाजसेवा व आर्थिक सक्षमीकरणाची उत्कट इच्छा आहे. 
                  अनेक वर्षांचा अनुभव आणि विविध प्रतिष्ठित पुरस्कार प्राप्त करून त्यांनी विश्वासू सल्लागार आणि दूरदृष्टी असलेले उद्योजक म्हणून स्वतःची ओळख निर्माण केली आहे.
                </p>
                <p>
                  त्यांच्या प्रवासाची सुरुवात एक साधे ध्येय घेऊन झाली: सर्वसमावेशक विमा सेवा पुरवणे आणि समाजाला काहीतरी परत देणे. 
                  हेच ध्येय जीवन आधार विमा सेवा केंद्र स्थापनेचे कारण ठरले, जे आज एक विश्वासार्ह नाव बनले आहे.
                </p>
                <p>
                  समाजातील व्यापक गरजा ओळखून त्यांनी जीवन आधार फाउंडेशनची स्थापना केली, जे विविध कल्याणकारी उपक्रमांद्वारे सामाजिक प्रश्नांवर काम करते. 
                  आर्थिक समावेशनाच्या दिशेने एक पाऊल पुढे टाकत त्यांनी जीवन आधार महिला ग्रामीण बिगरशेती पतसंस्थेची सुरुवात केली, 
                  जी ग्रामीण भागातील महिलांच्या आर्थिक सक्षमीकरणावर विशेष भर देते.
                </p>
                <p>
                  त्यांच्या नेतृत्वाने आणि समर्पणाने त्यांनी अनेकांचे जीवन बदलले असून एक सुरक्षित आणि सर्वसमावेशक समाज घडवण्यासाठी प्रेरणा दिली आहे.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col lg={12}>
              <h3 className="text-center mb-4">पुरस्कार आणि सन्मान</h3>
              <Row className="g-4">
                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <h4 className="award-badge mb-3">6 वेळा MDRT</h4>
                      <h5>मिलियन डॉलर राउंड टेबल</h5>
                      <p>
                        उत्कृष्ट व्यावसायिक ज्ञान, नैतिक मूल्ये आणि ग्राहक सेवेबद्दल 6 वेळा MDRT मानांकन प्राप्त.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <h4 className="award-badge mb-3">1 वेळा COT</h4>
                      <h5>कोर्ट ऑफ द टेबल</h5>
                      <p>
                        कोर्ट ऑफ द टेबलसाठी निवडले गेले, जे MDRT च्या सर्वोच्च स्तराचे प्रतिनिधित्व करते – उत्कृष्ट सेवा आणि उत्पादकतेचे प्रतीक.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <h4 className="award-badge mb-3">उद्योग सन्मान</h4>
                      <h5>अनेक उत्कृष्टता पुरस्कार</h5>
                      <p>
                        विमा आणि आर्थिक सेवाक्षेत्रातील उत्कृष्ट कार्य, नेतृत्व व योगदानासाठी अनेक राष्ट्रीय सन्मान प्राप्त.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          
          <Row>
            <Col lg={12}>
              <div className="text-center">
                <h3 className="mb-4">दृष्टी आणि मिशन</h3>
                <Row className="justify-content-center">
                  <Col lg={8}>
                    <p>
                      किशोर सलगर यांची दृष्टी म्हणजे असा समाज तयार करणे जिथे प्रत्येक व्यक्तीला आर्थिक सुरक्षा, दर्जेदार आरोग्य सेवा, 
                      शिक्षण आणि प्रगतीच्या संधी उपलब्ध असतील. त्यांचे मिशन म्हणजे विमा आणि आर्थिक ज्ञानाचा उपयोग करून 
                      समाजाच्या सर्व स्तरांपर्यंत पोहोचणे आणि सकारात्मक बदल घडवून आणणे.
                    </p>
                    <p>
                      त्यांच्या विविध उपक्रमांद्वारे ते सतत अशा भविष्यासाठी प्रयत्न करत आहेत जे अधिक समावेशक, सुरक्षित आणि 
                      वंचित घटकांसाठी आशादायक असेल.
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <ContactSection />
    </>
  );
};

export default AboutPage;
